<template>
  <h3 class="heading-three">
    <slot />
  </h3>
</template>

<script>
export default {
  name: 'HeadingThree'
}
</script>

<style lang="scss" scoped>
.heading-three {
  @extend %subhead-bold;
  color: $black;
  display: flex;
  padding: 16px 0 8px;
  border-bottom: 2px solid $primary;
}
</style>
